export const colors = {
  primary: {
    default: '#009be1',
    contrastText: '#fff',
    hover: '#0187C2',
  },
  light: '#d3f0ff',
  lightGrey: '#d9dbdd',
  grey: '#bcbcbc',
  darkGrey: '#696969',
  borderGrey: '#D4D4D4',
  black: '#000',
  white: '#fff',
  dark: '#222222',
  googleRed: '#cc3429',
  facebookBlue: '#3b5998 ',
  error: '#eb3030',
  errorShadow: '#c81e1e6e',
  darkBlue: '#032d60',
}

export const colorsAlternative = {
  primary: {
    default: '#696969',
    contrastText: '#fff',
    hover: '#696969',
  },
  light: '#f9f9f9',
  lightGrey: '#d9dbdd',
  grey: '#bcbcbc',
  darkGrey: '#696969',
  borderGrey: '#D4D4D4',
  black: '#000',
  white: '#fff',
  dark: '#222222',
  googleRed: '#cc3429',
  facebookBlue: '#3b5998 ',
  error: '#eb3030',
  errorShadow: '#c81e1e6e',
  darkBlue: '#032d60',
}

export const fonts = {
  regular: {
    'font-family': 'Maven Pro, sans-serif',
  },
  bold: {
    'font-family': 'Maven Pro, sans-serif',
    'font-weight': '700',
  },
  black: {
    'font-family': 'Maven Pro, sans-serif',
    'font-weight': '900',
  },
  medium: {
    'font-family': 'Maven Pro, sans-serif',
    'font-weight': '500',
  },
}
